import { Component, EventEmitter, Input, OnChanges, Output, Renderer2, SimpleChanges } from '@angular/core';
import { ColDef, ColGroupDef, Column, ColumnApi, GridOptions, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridI, paginationModel } from '../ag-grid/ag-grid.model'
import { CommonService } from '../../services/common.service';
import { AgGridService } from './ag-grid.service';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { DropdownModel, PaginationPageSizes } from '../../models/common.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ag-grid',
  templateUrl: './ag-grid.component.html',
  styleUrls: ['./ag-grid.component.scss']
})
export class AgGridComponent extends  CommonService implements OnChanges{
  paramsData: any[];
  gridApi:any;
  private gridColumnApi!: ColumnApi;
  isCustomRange:any
  overlayNoRowsTemplate =`<span style="font-size:16px" No Record Found</span>`;  public readonly pageLimitOptions = [
    { value: 25 },
    { value: 50 },
    { value: 75 },
    { value: 100 },
    { value: 1 },
  ];
  statusList:DropdownModel[]=[];
  dateRangeList:DropdownModel[]=[];
  getAllDropdownData:any[];
  selectedCellValue = '';
  paginationPageSizes            = new PaginationPageSizes();  
  @Input() dataModel: AgGridI;
  @Input() tableId: string;
  @Input() inputFocus: string='';
  @Input () tableRowCellEditable:boolean=true;
  @Input () addBlankRowOnEnter:boolean=false;
  @Input () autoGroupColumnDef:any;
  @Output() lastCellTriggered = new EventEmitter<any>();
  @Input () displayHeader =true;
  @Input () isFilter = false;
  @Input () isAmountList = false;
  @Input() totalRecords:number;
  @Input() pageSize:number;
  @Input() page:number;

  // filter parameter
  @Input() searchText: string='';
  @Input() statusValue: string='';
  @Input() plansValue: string='';
  @Output() changeSearchText = new EventEmitter<string>();
  @Output() changeStatusValue = new EventEmitter<string>();
  @Output() changePlansValue = new EventEmitter<string>();
  
  public components: {
    [p: string]: any;
  } = {
   // agColumnHeader: CustomHeaderComponent,
  };
  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 0,
    editable: true,
    resizable: true,
    singleClickEdit  : true,
    // suppressKeyboardEvent: this.suppressNavigation,
  };
  defaultColDefination: ColDef = {
    flex: 1,
    minWidth: 0,
    editable: false,
    resizable: true,
  };
  pagination = new paginationModel();

  @Input() columnDefs: (ColDef | ColGroupDef)[];
  @Input() rowData: any[];
  @Input() gridOptions!: GridOptions;
  @Input() navigateGridOption!: GridOptions;
  @Input() rowHeight = 28;
  @Input() headerHeight = 28;
  @Input() columnSettings:boolean=false;
  @Input() isSubscriptionListHeader=false;
  @Input() isShowStatusDropdown=true;
  @Input() isShowPlanDropdown=true;
  @Output() columnApi = new EventEmitter();
  @Output() gridApiEmit = new EventEmitter();
  @Output() rowClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() cellValueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() columnMoveChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() addNewBlankRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCellKeyDownValue: EventEmitter<any> = new EventEmitter<any>();
  @Output() previewClicked: EventEmitter<any> = new EventEmitter<any>();
 // @Output() onPagination: EventEmitter<Pagination> = new EventEmitter();
 // @Output() imgCellClicked: EventEmitter<Pagination> = new EventEmitter();
  @Output() onPageSizeUpdated: EventEmitter<any> = new EventEmitter();
  @Output() onPageSizeChanged: EventEmitter<number> = new EventEmitter();
  @Output() gridReady: EventEmitter<any> = new EventEmitter();
  @Output() onHeaderAddClick: EventEmitter<any> = new EventEmitter();
  @Output() onEditIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onCheckBoxClick: EventEmitter<any> = new EventEmitter();
  @Output() onPreviewIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onSendIconClick: EventEmitter<any> = new EventEmitter();
  @Output() cellEditingStopped: EventEmitter<any> = new EventEmitter<any>();
  @Output() onStatusButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onEditCreditButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onRefreshButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onExtendSubscription: EventEmitter<any> = new EventEmitter();
  @Output() onCellContextMenu: EventEmitter<any> = new EventEmitter();

  



  timerId
  currentPage: any;
  rowSelection: "single" | "multiple";
  constructor(public agGridService: AgGridService,
    public storageService: StorageService,
    public renderer: Renderer2,
    public router: Router,
    public toaster: ToastrService) {
    super(renderer);
  }

  ngOnChanges(changes: SimpleChanges): void {   
  }

  ngOnInit(): void {
    // this.getAllDropdown();
    // this.statusList = Object.keys(ActivityStatusType)
    // .filter((key) => !isNaN(Number(ActivityStatusType[key])))
    // .map((key) => ({
    //     id: Number(ActivityStatusType[key]),
    //     name: this.formatEnumKey(key),
    // }));
    // this.dateRangeList = Object.keys(DateRangeTypes)
    // .filter((key) => !isNaN(Number(DateRangeTypes[key])))
    // .map((key) => ({
    //     id: Number(DateRangeTypes[key]),
    //     name: this.formatEnumKey(key),
    // }));
   this.rowSelection = this.dataModel?.rowSelection
    this.loadCustomerlist();
    
  }

  private formatEnumKey(key: string): string {
    return key.replace(/([a-z])([A-Z])/g, "$1 $2");
  }

  loadCustomerlist(){
    
  }
  onSelectionChanged(event: SelectionChangedEvent){
    this.onSelectionChange.emit(event)

  }
  onCellKeyDown(gridOptions) {
    if (gridOptions.data.added != true) {
      gridOptions.data.edited = true;
    } 
    gridOptions.node.data[gridOptions.colDef.field] = gridOptions?.event?.target?.value??gridOptions.value;
    Object.entries(gridOptions.node.data).forEach((obj:any)=>{
      if((obj[1]) === ''){
        gridOptions.node.data[obj[0]]=null;
      }
    })
    const navigateToNextGrid=  this.navigateToNextGridCell(gridOptions)
    if ((gridOptions.event.key == "Enter"|| gridOptions.event.key =='ArrowRight' || gridOptions.event.key =='ArrowLeft') && navigateToNextGrid == false) {


      if((gridOptions.event.key == "Enter"|| gridOptions.event.key =='ArrowRight')){
        gridOptions.api.tabToNextCell();
      }else if(gridOptions.event.key =='ArrowLeft'){
        gridOptions.api.tabToPreviousCell()
      }

      
      var currentCell = gridOptions.api.getFocusedCell();
      const isCurrentCellEditable=currentCell.
      column.getColDef().editable == false
      console.log("isCurrentCellEditable",isCurrentCellEditable)
      if(isCurrentCellEditable){
        gridOptions.api.tabToNextCell();
      }
      var currentCell = gridOptions.api.getFocusedCell();
      gridOptions.api.stopEditing();
      gridOptions.api.clearFocusedCell();
      gridOptions.api.startEditingCell({
        rowIndex: currentCell.rowIndex,
        colKey: currentCell.column.colId,
      });
    }

    if(navigateToNextGrid == true)
      this.lastCellTriggered.emit({dataModel : this.dataModel, gridOptions : gridOptions});
   
    if((gridOptions.event.key == "Tab"  )){
      // this. storageService.onTabKeyPressed.next({dataModel : this.dataModel, gridOptions : gridOptions});
    }
  }

  navigateToNextGridCell(gridOptions):boolean {

    const rowCount = gridOptions.api.getModel().getRowCount();
    const lastIndex = rowCount > 0 ? rowCount - 1 : null;
   
    const columnApi: ColumnApi = gridOptions.columnApi;
    const allColumn: Column[] = columnApi.getColumns();
    const lastColumnDef= allColumn.length > 0 ? allColumn[allColumn.length - 1] : null;
    
    const cellRenderer = lastColumnDef.getColDef().cellRenderer?.name;
    let lastSecondColumn  = null;
      if('EditDeleteIconComponent' == cellRenderer){
        lastSecondColumn  = allColumn.length > 0 ? allColumn[allColumn.length - 2] : null;
      }

      const allVisibleColumn: Column[] = columnApi.getAllDisplayedColumns();
     
  
      if(allVisibleColumn[allVisibleColumn.length - 2]?.getColId() == gridOptions.column?.colId && gridOptions.rowIndex == lastIndex){
        return true
      }
      return false;
  }




  onMovingChanged($event){}
  onRowClicked($event){
    this.rowClicked.emit($event);
  }
  onDrag($event){}
  onCellClicked($event){}
  handleCustomButtonClick($event){}
  handleCustomHeaderEvent($event){}
  getRowStyle = params => {
    let style = {};

  }
onCellEditingStopped(event: any) {
 this.cellEditingStopped.emit(event);
}
  onCellValueChanged(event) {
    if (event.newValue != null) {
      if (event.data.added !== true) {
        event.data.edited = true;
      } 
    }
    this.cellValueChanged.emit(event);
  }

  getRowClass = (row) => {
    if (row.data.isScanned) {
     return "scanned_row_color";
   }
   };
   onPageSizeChange(): void {
    this.pagination.pageSize = Number(this.pageSize);
    this.emitPaginationModel();
  }

  onPageNumberChanged(event: number): void {
    this.pagination.pageNumber = event;
    this.emitPaginationModel();
  }

  private emitPaginationModel(): void {
    this.onPageSizeUpdated.emit({ ...this.pagination }); 
  }
  getStartRange(): number {
    return (this.page - 1) * this.pageSize + 1;
}

getEndRange(): number {
  if (this.pageSize === 1) return this.totalRecords;
    const endRange = this.page * this.pageSize;
    return endRange > this.totalRecords ? this.totalRecords : endRange;
}
   handleDeleteButtonClick(event: any): void {
    if(event != undefined)
    this.onDeleteIconClick.emit(event);
  }

  handleCheckBoxClick(event: any): void {
    if(event != undefined)
    this.onCheckBoxClick.emit(event);
  }

  handleEditeButtonClick(event: any): void {
    if(event != undefined)
    this.onEditIconClick.emit(event);
  }
  handlePreviewIconClick(event: any): void {
    if (event != undefined)
      this.onPreviewIconClick.emit(event);
  }
handleSendIconClick(event: any): void {
    if (event != undefined)
      this.onSendIconClick.emit(event);
  }
handleStatusButtonClick(event: any): void {
    if (event != undefined)
      this.onStatusButtonClick.emit(event);
  }
  handleEditCreditButtonClick(event: any): void {
    if (event != undefined)
      this.onEditCreditButtonClick.emit(event);
  }
  handleRefreshButtonClick(event: any): void {
    if (event != undefined)
      this.onRefreshButtonClick.emit(event);
  }
  handleSaveExtendSubsButtonClick(event: any): void {
    if (event != undefined)
      this.onExtendSubscription.emit(event);
  }

  handleCellContextMenu(event: any): void {
    event?.event?.preventDefault();
    const text = event?.event?.target?.innerText || event?.value || '';
    navigator.clipboard.writeText(text);
    this.toaster.success('Text copied');
  }
  
  //#region onGridReady
  async onGridReady(params) {
    params.api.addEventListener('deleteButtonClick', this.handleDeleteButtonClick.bind(this));
    params.api.addEventListener('editButtonClick', this.handleEditeButtonClick.bind(this));
    params.api.addEventListener('checkBoxClick', this.handleCheckBoxClick.bind(this));
    params.api.addEventListener('customButtonClick', this.handleCustomButtonClick.bind(this));
    params.api.addEventListener('previewIconClick', this.handlePreviewIconClick.bind(this));
    params.api.addEventListener('sendButtonClick', this.handleSendIconClick.bind(this));
    params.api.addEventListener('StatusButtonClick', this.handleStatusButtonClick.bind(this));
    params.api.addEventListener('editCreditButtonClick', this.handleEditCreditButtonClick.bind(this));
    params.api.addEventListener('refreshButtonClick', this.handleRefreshButtonClick.bind(this));
    params.api.addEventListener('onSaveExtendSubscription', this.handleSaveExtendSubsButtonClick.bind(this));
    params.api.addEventListener('customCellContextMenu', this.handleCellContextMenu.bind(this));
    

    this.rowData= this.rowData??[]
    this.agGridService.setGridApi(params);
    this.agGridService.setGridColumnApi(params.columnApi);
    this.paramsData = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if(this.dataModel.headerHeight == undefined)
      this.dataModel.headerHeight = 30;
    
    this.gridReady.emit(params);
    this.gridApiEmit.emit(params.api);
    this.overlayNoRowsTemplate =`<span style="font-size:16px" No Record Found</span>`;
    var storageName = this.dataModel.storageName;
        // For Column Save State
        var colState = this.storageService.retrieve(this.dataModel.storageName != undefined ? this.dataModel?.storageName.toString() : "");
        if (colState == undefined) {
          // colState= await this.agGridService.getAllColumnDefination(this.dataModel);
         // // call api to get col def using this.dataModel.storageName.toString()
        }
        if (!colState) {
          return;
        }
      
        this.gridColumnApi.applyColumnState({
          state: colState,
          applyOrder: true,
        });
  }
  //#endregion

  range(event){
    this.isCustomRange = event
  }

  getAllDropdown(){
    this.agGridService.getAllDropdownList().subscribe((res)=>{
     this.getAllDropdownData =  res.response;
     this.storageService.store('getAllDropdownData',this.getAllDropdownData)
    })
  }

// search filter
  searchFilter(value){
    clearTimeout(this.timerId);
    this.timerId = setTimeout(() => {
      this.changeSearchText.emit(value);
    }, 500);
  }

}
